import Playable from './Playable'

class PlayableZone extends Playable {

  constructor(json_data, json_included) {
    super(json_data, json_included)
    this.zone = this.findIncluded(this.relationships['zone'])
    this.app = this.findIncluded(this.zone.relationships['app'])
  }

  get maxParticipationRadius() {
    return this.zone.attributes['max-participation-radius']
  }

  eventRequiresGeoLocation() {
    // Global zones with max_participation_radius require geolocation for event creation.
    // Localized zones have a fixed location, so creator location is not required.
    //
    // Only global zones require geolocation (even though localized zones may also
    // have a max participation radius).
    const zoneType = this.zone?.attributes?.['zone-type'] ?? this.zone?.attributes?.zone_type
    const radius = this.maxParticipationRadius
    return zoneType === 'global' && radius != null && radius > 0
  }
}

export default PlayableZone
